import { Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import EditModal from './shared_edit_modal';
import { BrokerError, BrokerPanel, deleteRecord, modifyRecordArray, getChildCompanyUrlSuffix } from './shared';
import Button from 'shared/button';

export interface Region {
  canModify: boolean;
  id: number;
  name: string;
}

export default function Regions(props: { regions: Region[] }) {
  const [regions, setRegions] = useState<Region[]>(props.regions);
  const [modalObject, setModalObject] = useState<{ isOpen: boolean; id: string | number }>({ isOpen: false, id: '' });
  const [error, setError] = useState<string>('');

  const openModal = (id: string | number) => setModalObject({ isOpen: true, id });
  const closeModal = () => setModalObject({ isOpen: false, id: '' });
  const regionToEdit = modalObject.id === ''
    ? null
    : regions.find(region => region.id === modalObject.id);

  const handleFormSubmit = (newRegion: Region) => {
    modifyRecordArray(newRegion, setRegions, regions, 'name', modalObject, closeModal);
  };

  const deleteRegion = ({ name, id }: { name: string; id: number }) => {
    const urlSuffix = getChildCompanyUrlSuffix();
    deleteRecord(id, name, '/company_regions', 'Region', setRegions, setError, urlSuffix);
  };

  const editFields = [{ name: 'name', isRequired: true, value: regionToEdit?.name }];

  const addNewRegion = () => openModal('');

  return (
    <React.Fragment>
      <Modal
        dialogClassName="modal-sm"
        show={modalObject.isOpen}
        onHide={closeModal}
      >
        <EditModal
          databaseName="company_region"
          editFields={editFields}
          id={modalObject.id}
          key={`${modalObject.isOpen}-${modalObject.id}`}
          objectName="Region"
          onCloseModal={closeModal}
          onSuccessfulFormSubmit={handleFormSubmit}
        />
      </Modal>
      <div className="d-flex justify-content-between mb-3 align-items-center top-buffer-xl">
        <h2 className="m-0">Regions</h2>
        <Button.Primary onClick={addNewRegion}>Add Region</Button.Primary>
      </div>

      <BrokerError error={error}/>
      <BrokerPanel
        cantModifyMessage="Corporate Region"
        deleteRecord={deleteRegion}
        firstColumnIdentifier="name"
        openModal={openModal}
        recordName="Region"
        records={regions}
        secondColumnIdentifier=""
        onClick={addNewRegion}
      />

    </React.Fragment>
  );
}
